import { WarningAmberRounded } from "@mui/icons-material";
import { Box, Button, Card, CardContent, CardHeaderProps, InputAdornment, CardHeader as MuiCardHeader, Paper, Typography, useTheme } from "@mui/material";
import { getBillingState, getBillingStateColor, getBillingStateText, lastMeasureDay } from ".";
import { iconByName } from "../../components/IconPicker";
import { TextInput } from "../../components/form/TextInput";
import { Information } from "../../icons";
import { useCachedStore, useIsMobile, useRemoteData } from "../../models/Hooks";
import { isMobile } from "../../utils";
import { meterTariffStore } from "../measure/MeterTariffCombo";
import { tariffStore } from "../project/tariff/TariffCombo";
import { NavLinkComponent } from "../../Router";
import { NoDataText } from "../../components/data/DataTable";

function CardHeader(props: CardHeaderProps) {
    return <MuiCardHeader {...props}
        titleTypographyProps={{ variant: isMobile() ? 'h2' : 'h1', ...props?.titleTypographyProps }}
        subheaderTypographyProps={{ variant: isMobile() ? 'caption' : 'body2', ...props?.subheaderTypographyProps }}
    />;
}

interface MeasureWidgetData {
    Measures: {
        Cur: number
        Prev?: number
        MeterTariffId: number
    }[]

    Meters: {
        All: number,
        Overdue: number
    }[]
}

function DesktopWidget() {
    const [data] = useRemoteData<MeasureWidgetData>('MeasureAnalytic');
    const [meters] = useCachedStore(meterTariffStore);
    const [tariffs] = useCachedStore(tariffStore);

    if (data && !data.Measures) {
        return <></>;
    }

    return <Card sx={{ flex: 1 }}>
        <CardHeader title="Показания счетчиков" subheader={`Принимаются до ${lastMeasureDay} числа каждого месяца`} />
        {meters?.length ? <CardContent sx={{ gap: 2, display: 'flex', flexDirection: 'column' }} >
            {data?.Measures.map(x => {
                let meter = meters.find(t => t.Id == x.MeterTariffId);
                let tarif = tariffs?.find(t => t.Id == meter?.Obj?.TariffId);
                return <TextInput key={x.MeterTariffId}
                    name={x.MeterTariffId}
                    onChange={e => { }}
                    label={meter?.Value || x.MeterTariffId.toString()}
                    value={x.Cur || undefined}
                    inputProps={{
                        type: 'number',
                        placeholder: 'Введите значение (предыдущее: ' + x.Prev + ')',
                        min: x.Prev,
                        endAdornment: <InputAdornment position="end">{iconByName(tarif?.Obj?.Icon, { fontSize: 'small', color: 'primary' })}</InputAdornment>
                    }} />
            })}
            <Box>
                <Button variant="contained" sx={{ ml: 'auto' }}>Сохранить</Button>
            </Box>
        </CardContent>
            : <NoDataText>Отсутствуют счетчики</NoDataText>}
    </Card>;
}

function MobileWidget() {
    const theme = useTheme();
    const billingState = getBillingState();
    return <Paper elevation={2} component={NavLinkComponent} route={[['page', 'measure'], ['id', billingState ? 'new' : null]]}
        sx={{ gap: 2, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'space-between' }}>
        <Box display="flex" gap={1} sx={{ "&>svg": { width: 50 } }} >
            <Box>
                <Typography variant="h2" mb={1.5} display="flex" justifyContent="space-between">Счетчики {Information}</Typography>
                <Typography component="div" variant="body2" color="textSecondary">принимаются до {lastMeasureDay} числа каждого месяца</Typography>
            </Box>
        </Box>
        {billingState && false ? <Box sx={{ gap: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
            <Button variant="contained" startIcon={<WarningAmberRounded />} sx={{
                fontSize: 8,
                p: 1,
                textAlign: 'left',
                background: '#FFEAE6',
                color: theme.palette[getBillingStateColor()].main
            }}>{getBillingStateText()}</Button>
            {/*<Button variant="contained">Передать показания</Button>*/}
        </Box> : null}
    </Paper>;
}

export function MeasuresWidget() {
    const ism = useIsMobile();
    return ism ? <MobileWidget /> : <DesktopWidget />;
}